import { zChargingStationCommonSchema } from "./chargingStation.common";
// ChargingStation DTO схема (расширяет базовую схему)
export const zChargingStationSchemaDto = zChargingStationCommonSchema;
export const zChargingStationSchemaCreateDto = zChargingStationSchemaDto.omit({
    id: true,
});
